import Category from '@shared/classes/category';
import categoriesRequest from './request';
import { Observable } from 'rxjs';

const categoriesObservable = new Observable<Category[]>((subscriber) => {
  subscriber.next([]);
  categoriesRequest()
    .then((categories) => {
      subscriber.next(categories);
      subscriber.complete();
    })
    .catch(() => {
      subscriber.error();
      subscriber.complete();
    });
});

export default categoriesObservable;
